import QACategoryEntity from "./qa_category.entity";

export interface IQAAgentEntity {
    id: string;
    name: string;
    description?: string;
    clientId?: string;
    opTypeId?: string;
    categories: QACategoryEntity[];
    target?: number;
    flexibility: number;
    files: { file_id: string; filename: string; vector_store_id: string }[];
    assistant_id: string;
    vector_store_id: string;
    is_assistant?: boolean;

}

export default class QAAgentEntity implements IQAAgentEntity{
    id: string;
    name: string;
    description?: string | undefined;
    clientId?: string | undefined;
    opTypeId?: string | undefined;
    categories: QACategoryEntity[];
    target?: number;
    flexibility: number;
    files: { file_id: string; filename: string; vector_store_id: string }[];
    assistant_id: string;
    vector_store_id: string;
    is_assistant?: boolean;

    constructor(_: IQAAgentEntity) {
        this.id = _.id;
        this.name = _.name;
        this.description = _.description;
        this.clientId = _.clientId;
        this.opTypeId = _.opTypeId;
        this.categories = _.categories;
        this.target = _.target;
        this.flexibility = _.flexibility;
        this.assistant_id = _.assistant_id;
        this.vector_store_id = _.vector_store_id;
        this.files = _.files ?? [];
        this.is_assistant = _.is_assistant;

    }

    getMaxPoints(): number {
        return this.categories.reduce((acc, category) => acc + category.getMaxQuestionPoints(), 0);
    }

}